import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { logout } from '../actions/constants'

export interface IAppInfoState {
  appVersion: string | null
}

const initialState: IAppInfoState = {
  appVersion: null
}

export const appInfoSlice = createSlice({
  name: 'app_info',
  initialState,
  reducers: {
    setAppInfoConfig: (state, action: PayloadAction<IAppInfoState>) => {
      state.appVersion = action.payload.appVersion
    }
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialState)
  }
})

export const { setAppInfoConfig } = appInfoSlice.actions

export default appInfoSlice.reducer
